const middleware = {}

middleware['adminAuthenticated'] = require('../middleware/adminAuthenticated.js')
middleware['adminAuthenticated'] = middleware['adminAuthenticated'].default || middleware['adminAuthenticated']

middleware['ctoUserAuthenticated'] = require('../middleware/ctoUserAuthenticated.js')
middleware['ctoUserAuthenticated'] = middleware['ctoUserAuthenticated'].default || middleware['ctoUserAuthenticated']

export default middleware
